import { createSlice } from '@reduxjs/toolkit';

import type { SetorState } from '@/types/setor/setorTypes';

import {
  atualizarSetor,
  buscarSetorPorId,
  criarSetor,
  excluirSetor,
  listarSetores,
} from './actions';

const initialState: SetorState = {
  setores: [],
  currentSetor: null,
  total: 0,
  page: 1,
  limit: 20,
  isLoading: false,
  error: null,
};

const setorSlice = createSlice({
  name: 'setor',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCurrentSetor: (state) => {
      state.currentSetor = null;
    },
    clearSetores: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(listarSetores.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(listarSetores.fulfilled, (state, action) => {
        state.isLoading = false;
        const arg = action.meta.arg as { setorPaiId?: string | null } | undefined;
        if (arg && arg.setorPaiId !== undefined && arg.setorPaiId !== null) {
          const map = new Map(state.setores.map((s) => [s.id, s] as const));
          for (const item of action.payload.data) {
            map.set(item.id, item);
          }
          state.setores = Array.from(map.values());
          state.total = Math.max(state.total, action.payload.total);
        } else {
          state.setores = action.payload.data;
          state.total = action.payload.total;
        }
      })
      .addCase(listarSetores.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(buscarSetorPorId.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(buscarSetorPorId.fulfilled, (state, action) => {
        state.isLoading = false;
        state.currentSetor = action.payload;
      })
      .addCase(buscarSetorPorId.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(criarSetor.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(criarSetor.fulfilled, (state, action) => {
        state.isLoading = false;
        state.setores.unshift(action.payload);
      })
      .addCase(criarSetor.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(atualizarSetor.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(atualizarSetor.fulfilled, (state, action) => {
        state.isLoading = false;
        const index = state.setores.findIndex((s) => s.id === action.payload.id);
        if (index !== -1) {
          state.setores[index] = action.payload;
        }
        if (state.currentSetor?.id === action.payload.id) {
          state.currentSetor = action.payload;
        }
      })
      .addCase(atualizarSetor.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(excluirSetor.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(excluirSetor.fulfilled, (state, action) => {
        state.isLoading = false;
        state.setores = state.setores.filter((s) => s.id !== action.payload);
      })
      .addCase(excluirSetor.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearSetores } = setorSlice.actions;
export default setorSlice.reducer;
